// @ts-nocheck
/**
 * ツインキーシステム - 究極パッシブ定義
 *
 * 42種の究極パッシブ（★3解放時に獲得）
 * 仕様書: twin_key_generic_skills_passives_v1.md
 */

import { PASSIVE_EFFECT_TYPES, PASSIVE_CONDITIONS } from './attributePassives';

// ========================================
// 究極パッシブカテゴリ
// ========================================

export const ULTIMATE_CATEGORIES = {
  ATTACK: 'attack',     // 攻撃系
  DEFENSE: 'defense',   // 防御系
  HEAL: 'heal',         // 回復系
  SUPPORT: 'support',   // 支援系
  SPECIAL: 'special',   // 特殊系
};

// ========================================
// 攻撃系究極パッシブ（11種）
// ========================================

export const ATTACK_ULTIMATES = {
  A1: {
    id: 'A1',
    name: '2回行動',
    description: '20%で同じターンにもう1回行動',
    category: ULTIMATE_CATEGORIES.ATTACK,
    effects: [{ type: 'extra_turn', chance: 20 }],
  },
  A2: {
    id: 'A2',
    name: '確定クリティカル',
    description: 'HP30%以下の敵に確定クリ',
    category: ULTIMATE_CATEGORIES.ATTACK,
    effects: [{ type: 'guaranteed_crit', condition: PASSIVE_CONDITIONS.TARGET_HP_BELOW, threshold: 30 }],
  },
  A3: {
    id: 'A3',
    name: '追撃',
    description: '攻撃時、追加で攻撃力×30%ダメージ',
    category: ULTIMATE_CATEGORIES.ATTACK,
    effects: [{ type: 'follow_up_attack', multiplier: 0.3 }],
  },
  A4: {
    id: 'A4',
    name: '貫通',
    description: '防御を50%無視',
    category: ULTIMATE_CATEGORIES.ATTACK,
    effects: [{ type: 'armor_pierce', value: 50 }],
  },
  A5: {
    id: 'A5',
    name: '処刑',
    description: 'HP20%以下の敵に即死判定（30%）',
    category: ULTIMATE_CATEGORIES.ATTACK,
    effects: [{ type: 'execute', threshold: 20, chance: 30 }],
  },
  A6: {
    id: 'A6',
    name: '連撃',
    description: '通常攻撃が2回になる',
    category: ULTIMATE_CATEGORIES.ATTACK,
    effects: [{ type: 'double_attack' }],
  },
  A7: {
    id: 'A7',
    name: '火傷爆発',
    description: '火傷状態の敵へのダメージ+40%',
    category: ULTIMATE_CATEGORIES.ATTACK,
    effects: [{ type: PASSIVE_EFFECT_TYPES.STATUS_DAMAGE, status: 'burn', value: 40 }],
  },
  A8: {
    id: 'A8',
    name: '氷砕き',
    description: '凍結状態の敵に確定クリティカル+ダメージ+30%',
    category: ULTIMATE_CATEGORIES.ATTACK,
    effects: [
      { type: 'guaranteed_crit', condition: PASSIVE_CONDITIONS.TARGET_STATUS, status: 'freeze' },
      { type: PASSIVE_EFFECT_TYPES.STATUS_DAMAGE, status: 'freeze', value: 30 },
    ],
  },
  A9: {
    id: 'A9',
    name: '猛毒強化',
    description: '自身が与える毒ダメージ2倍',
    category: ULTIMATE_CATEGORIES.ATTACK,
    effects: [{ type: 'poison_damage_boost', multiplier: 2 }],
  },
  A10: {
    id: 'A10',
    name: '闇の捕食',
    description: '撃破時、敵の攻撃力5%を永続獲得（最大25%）',
    category: ULTIMATE_CATEGORIES.ATTACK,
    effects: [{ type: PASSIVE_EFFECT_TYPES.ON_KILL, effect: { type: 'steal_atk', value: 5, max: 25 } }],
  },
  A11: {
    id: 'A11',
    name: '時の支配者',
    description: '時止状態の敵に2回攻撃',
    category: ULTIMATE_CATEGORIES.ATTACK,
    effects: [{ type: 'double_attack', condition: PASSIVE_CONDITIONS.TARGET_STATUS, status: 'time_stop' }],
  },
};

// ========================================
// 防御系究極パッシブ（9種）
// ========================================

export const DEFENSE_ULTIMATES = {
  D1: {
    id: 'D1',
    name: '無敵',
    description: '戦闘開始時1ターン無敵',
    category: ULTIMATE_CATEGORIES.DEFENSE,
    effects: [{ type: PASSIVE_EFFECT_TYPES.ON_BATTLE_START, effect: { type: 'invincible', duration: 1 } }],
  },
  D2: {
    id: 'D2',
    name: '反射',
    description: '受けたダメージの30%を反射',
    category: ULTIMATE_CATEGORIES.DEFENSE,
    effects: [{ type: 'damage_reflect', value: 30 }],
  },
  D3: {
    id: 'D3',
    name: 'ダメージ上限',
    description: '1回の被ダメージ上限を最大HPの30%に',
    category: ULTIMATE_CATEGORIES.DEFENSE,
    effects: [{ type: 'damage_cap', value: 30 }],
  },
  D4: {
    id: 'D4',
    name: '根性',
    description: 'HP1以上なら致死ダメージを1回耐える',
    category: ULTIMATE_CATEGORIES.DEFENSE,
    effects: [{ type: 'guts', uses: 1 }],
  },
  D5: {
    id: 'D5',
    name: 'かばう',
    description: 'HP低い味方への攻撃を自動でかばう',
    category: ULTIMATE_CATEGORIES.DEFENSE,
    effects: [{ type: 'cover', chance: 100, condition: 'lowest_hp' }],
  },
  D6: {
    id: 'D6',
    name: 'バリア',
    description: '戦闘開始時、最大HP30%分のシールド',
    category: ULTIMATE_CATEGORIES.DEFENSE,
    effects: [{ type: PASSIVE_EFFECT_TYPES.ON_BATTLE_START, effect: { type: 'shield', value: 30 } }],
  },
  D7: {
    id: 'D7',
    name: '分裂',
    description: '戦闘不能時、HP30%の分身を1体生成',
    category: ULTIMATE_CATEGORIES.DEFENSE,
    effects: [{ type: 'split', hpPercent: 30 }],
  },
  D8: {
    id: 'D8',
    name: '硬化',
    description: '被弾時、防御↑×1を獲得（最大3スタック）',
    category: ULTIMATE_CATEGORIES.DEFENSE,
    effects: [{ type: PASSIVE_EFFECT_TYPES.ON_HIT, effect: { type: 'buff', buff: 'def_up', stacks: 1, maxStacks: 3 } }],
  },
  D9: {
    id: 'D9',
    name: '霧化',
    description: 'HP30%以下で被弾時50%回避',
    category: ULTIMATE_CATEGORIES.DEFENSE,
    effects: [{ type: PASSIVE_EFFECT_TYPES.EVASION_RATE, value: 50, condition: PASSIVE_CONDITIONS.HP_BELOW, threshold: 30 }],
  },
};

// ========================================
// 回復系究極パッシブ（7種）
// ========================================

export const HEAL_ULTIMATES = {
  H1: {
    id: 'H1',
    name: '復活',
    description: '戦闘中1回、HP1%で復活',
    category: ULTIMATE_CATEGORIES.HEAL,
    effects: [{ type: 'revive', hpPercent: 1, uses: 1 }],
  },
  H2: {
    id: 'H2',
    name: '吸収',
    description: '与ダメージの20%をHP回復',
    category: ULTIMATE_CATEGORIES.HEAL,
    effects: [{ type: PASSIVE_EFFECT_TYPES.LIFESTEAL, value: 20 }],
  },
  H3: {
    id: 'H3',
    name: '超再生',
    description: 'ターン終了時HP10%回復',
    category: ULTIMATE_CATEGORIES.HEAL,
    effects: [{ type: PASSIVE_EFFECT_TYPES.REGEN, value: 10 }],
  },
  H4: {
    id: 'H4',
    name: '回復強化',
    description: '受ける回復効果+50%',
    category: ULTIMATE_CATEGORIES.HEAL,
    effects: [{ type: PASSIVE_EFFECT_TYPES.HEAL_RECEIVED, value: 50 }],
  },
  H5: {
    id: 'H5',
    name: '瀕死回復',
    description: 'HP20%以下になった時、1回だけHP50%回復',
    category: ULTIMATE_CATEGORIES.HEAL,
    effects: [{ type: 'emergency_heal', threshold: 20, healPercent: 50, uses: 1 }],
  },
  H6: {
    id: 'H6',
    name: '生命共有',
    description: 'ターン終了時、味方全体をHP5%回復',
    category: ULTIMATE_CATEGORIES.HEAL,
    effects: [{ type: PASSIVE_EFFECT_TYPES.ON_TURN_END, effect: { type: 'heal_all', value: 5 } }],
  },
  H7: {
    id: 'H7',
    name: '死の淵からの帰還',
    description: '蘇生された時、HP50%で復帰（通常は30%）',
    category: ULTIMATE_CATEGORIES.HEAL,
    effects: [{ type: 'revive_bonus', hpPercent: 50 }],
  },
};

// ========================================
// 支援系究極パッシブ（4種）
// ========================================

export const SUPPORT_ULTIMATES = {
  S1: {
    id: 'S1',
    name: '全体バフ',
    description: '味方全体の攻撃+15%',
    category: ULTIMATE_CATEGORIES.SUPPORT,
    effects: [{ type: PASSIVE_EFFECT_TYPES.ALLY_BUFF, stat: 'atk', value: 15 }],
  },
  S2: {
    id: 'S2',
    name: 'オーラ',
    description: '味方全体の被ダメージ-10%',
    category: ULTIMATE_CATEGORIES.SUPPORT,
    effects: [{ type: PASSIVE_EFFECT_TYPES.ALLY_BUFF, stat: 'damage_reduce', value: 10 }],
  },
  S3: {
    id: 'S3',
    name: '鼓舞',
    description: '味方が倒れた時、生存者の攻撃+20%',
    category: ULTIMATE_CATEGORIES.SUPPORT,
    effects: [{ type: 'on_ally_death', effect: { type: 'buff_survivors', stat: 'atk', value: 20 } }],
  },
  S4: {
    id: 'S4',
    name: '継承',
    description: '自分が倒れた時、味方1体にバフ全移譲',
    category: ULTIMATE_CATEGORIES.SUPPORT,
    effects: [{ type: 'inherit_buffs' }],
  },
};

// ========================================
// 特殊系究極パッシブ（11種）
// ========================================

export const SPECIAL_ULTIMATES = {
  X1: {
    id: 'X1',
    name: '弱点無効',
    description: '属性相性の不利を無効化',
    category: ULTIMATE_CATEGORIES.SPECIAL,
    effects: [{ type: 'ignore_attribute_weakness' }],
  },
  X2: {
    id: 'X2',
    name: '状態異常無効',
    description: '状態異常を完全無効',
    category: ULTIMATE_CATEGORIES.SPECIAL,
    effects: [{ type: PASSIVE_EFFECT_TYPES.STATUS_IMMUNITY, all: true }],
  },
  X3: {
    id: 'X3',
    name: '先制',
    description: '必ず最初に行動',
    category: ULTIMATE_CATEGORIES.SPECIAL,
    effects: [{ type: 'preemptive' }],
  },
  X4: {
    id: 'X4',
    name: 'カウンター',
    description: '被弾時100%で反撃',
    category: ULTIMATE_CATEGORIES.SPECIAL,
    effects: [{ type: PASSIVE_EFFECT_TYPES.COUNTER, multiplier: 1.0, chance: 100 }],
  },
  X5: {
    id: 'X5',
    name: '不屈',
    description: '状態異常のターン数-1',
    category: ULTIMATE_CATEGORIES.SPECIAL,
    effects: [{ type: 'status_duration_reduce', value: 1 }],
  },
  X6: {
    id: 'X6',
    name: '適応',
    description: '同じ敵からの連続攻撃ダメージ-20%ずつ',
    category: ULTIMATE_CATEGORIES.SPECIAL,
    effects: [{ type: 'adaptation', reduction: 20, condition: PASSIVE_CONDITIONS.SAME_ENEMY_HIT }],
  },
  X7: {
    id: 'X7',
    name: 'コピー',
    description: '戦闘開始時、ランダムな敵のパッシブ1つをコピー',
    category: ULTIMATE_CATEGORIES.SPECIAL,
    effects: [{ type: PASSIVE_EFFECT_TYPES.ON_BATTLE_START, effect: { type: 'copy_passive', target: 'random_enemy' } }],
  },
  X8: {
    id: 'X8',
    name: '野生の直感',
    description: '状態異常付与時、50%で無効化して攻撃↑×1獲得',
    category: ULTIMATE_CATEGORIES.SPECIAL,
    effects: [{ type: 'status_counter', chance: 50, effect: { type: 'buff', buff: 'atk_up', stacks: 1 } }],
  },
  X9: {
    id: 'X9',
    name: '魂喰い',
    description: '敵撃破時、スキルのCD1短縮',
    category: ULTIMATE_CATEGORIES.SPECIAL,
    effects: [{ type: PASSIVE_EFFECT_TYPES.ON_KILL, effect: { type: 'cd_reduce', value: 1 } }],
  },
  X10: {
    id: 'X10',
    name: '疾風怒濤',
    description: '速度が敵より30以上高い時、ダメージ+25%',
    category: ULTIMATE_CATEGORIES.SPECIAL,
    effects: [{ type: 'speed_damage', threshold: 30, value: 25 }],
  },
  X11: {
    id: 'X11',
    name: '幽体化',
    description: '被弾時20%で完全無効化',
    category: ULTIMATE_CATEGORIES.SPECIAL,
    effects: [{ type: PASSIVE_EFFECT_TYPES.EVASION_RATE, value: 20, nullify: true }],
  },
};

// ========================================
// 全究極パッシブマップ
// ========================================

export const ALL_ULTIMATE_PASSIVES = {
  ...ATTACK_ULTIMATES,
  ...DEFENSE_ULTIMATES,
  ...HEAL_ULTIMATES,
  ...SUPPORT_ULTIMATES,
  ...SPECIAL_ULTIMATES,
};

// ========================================
// ヘルパー関数
// ========================================

/**
 * 究極パッシブIDから取得
 * @param {string} ultimateId - 究極パッシブID（例: 'A1', 'D3'）
 * @returns {Object|null} 究極パッシブデータ
 */
export const getUltimatePassive = (ultimateId) => {
  return ALL_ULTIMATE_PASSIVES[ultimateId] || null;
};

/**
 * カテゴリ別究極パッシブ一覧を取得
 * @param {string} category - カテゴリ
 * @returns {Object[]} 究極パッシブ配列
 */
export const getUltimatesByCategory = (category) => {
  return Object.values(ALL_ULTIMATE_PASSIVES).filter(ult => ult.category === category);
};

/**
 * 究極パッシブIDのリストを取得
 * @returns {string[]} ID配列
 */
export const getAllUltimateIds = () => {
  return Object.keys(ALL_ULTIMATE_PASSIVES);
};

/**
 * 究極パッシブの総数を取得
 * @returns {number} 42
 */
export const getUltimateCount = () => {
  return Object.keys(ALL_ULTIMATE_PASSIVES).length;
};

export default {
  ULTIMATE_CATEGORIES,
  ATTACK_ULTIMATES,
  DEFENSE_ULTIMATES,
  HEAL_ULTIMATES,
  SUPPORT_ULTIMATES,
  SPECIAL_ULTIMATES,
  ALL_ULTIMATE_PASSIVES,
  getUltimatePassive,
  getUltimatesByCategory,
  getAllUltimateIds,
  getUltimateCount,
};
